module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-8-14a4c50d9796174632f9a13d7534e35e.jpg";